import PayPalCommerceFastlanePaymentMethod from './PayPalCommerceFastlanePaymentMethod';

export default PayPalCommerceFastlanePaymentMethod;
